/**
 * Project_Entity type guard.
 *
 * @param {any} projectJson Project object from API
 * @returns {boolean} Return true if type is Project_Entity
 */
function validator(projectJson: unknown): projectJson is Project_Entity {
  if (typeof projectJson === "object" && projectJson != null) {
    Project_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(projectJson).includes(element))
        console.log("Field ${element} is null or undefined");
    });
  }
  return true;
}

export default class Project_Entity {
  static requiredFields = [
    "id",
    "name",
    "description",
    "status",
    "createdAt",
    "updatedAt",
  ];

  constructor(projectJson: unknown) {
    if (validator(projectJson)) {
      this.id = projectJson.id;
      this.name = projectJson.name;
      this.refID = projectJson.refID;
      this.description = projectJson.description;
      this.status = projectJson.status;
      this.active = projectJson.active;
      this.createdAt = projectJson.createdAt;
      this.updatedAt = projectJson.updatedAt;
    } else {
      throw new Error(
        "Failed to create new instance of ${ Project_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  name?: string;
  description?: string;
  refID?: number;
  status?: string;
  active?: boolean;
  createdAt?: string;
  updatedAt?: string;
}
